/**
 * @generated SignedSource<<257c212b2457fee4ae6dc1040a492128>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type salesChannelDisconnectTaskPollerQuery$variables = {
  id: string;
};
export type salesChannelDisconnectTaskPollerQuery$data = {
  readonly productSwitcherTask: {
    readonly lastError: string;
    readonly state: number;
    readonly taskID: number;
  } | null;
};
export type salesChannelDisconnectTaskPollerQuery = {
  response: salesChannelDisconnectTaskPollerQuery$data;
  variables: salesChannelDisconnectTaskPollerQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "taskID",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastError",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "salesChannelDisconnectTaskPollerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTask",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "salesChannelDisconnectTaskPollerQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "ProductSwitcherTask",
        "kind": "LinkedField",
        "name": "productSwitcherTask",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          (v3/*:: as any*/),
          (v4/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1201b94361a4a557cd67c25dee650e65",
    "id": null,
    "metadata": {},
    "name": "salesChannelDisconnectTaskPollerQuery",
    "operationKind": "query",
    "text": "query salesChannelDisconnectTaskPollerQuery(\n  $id: ID!\n) {\n  productSwitcherTask(id: $id) {\n    taskID\n    state\n    lastError\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1643bdc6bdc7790735eca7bf9e5a5564";

export default node;
